import { ObjectValidation } from '../../../../../utils/component-validations';
import Super from '../../../core/base.gjs';
import styles from './trigger.module.scss';
import svgJar from 'ember-svg-jar/helpers/svg-jar';

export default class SpdsActionButtonSplitTrigger extends Super {
  arguments = [new ObjectValidation({ required: ['button'] })];
  baseClass = 'spds-action-button-split-trigger';
  classesToMapToArgs = ['disabled', 'open'];
  styles = styles;

  <template>
    <@button
      @disabled={{@disabled}}
      @fitContent={{true}}
      @size={{@size}}
      {{this.setupComponent}}
      {{this.validateArguments}}
      aria-expanded={{if @open "true" "false"}}
      aria-haspopup="menu"
      class={{this.classes}}
      ...attributes
    >
      {{svgJar "dropdown-caret" class="spds-action-button-split-trigger-caret"}}
    </@button>
  </template>
}
